const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMERIC_SEGMENT = /^[0-9]+$/;

/**
 * 경로/키의 리소스 id 세그먼트를 placeholder 로 치환한다.
 *
 * 세그먼트 단위로만 판정한다 — 경로/키 전체에 정규식을 돌려 치환하면 `v2` 같은 버전 세그먼트나
 * `2026-08-04` 같은 날짜가 부분 매칭으로 깨진다.
 */
export function maskIdSegment(segment: string): string {
  if (UUID_SEGMENT.test(segment)) return ':uuid';
  if (NUMERIC_SEGMENT.test(segment)) return ':id';

  return segment;
}
